import type { LeadsAdvancedFilters } from '../types';

/**
 * Tira do filtro "Etapa" as etapas que deixaram de fazer sentido porque o
 * funil dono saiu da seleção.
 *
 * Sem isto, desmarcar um funil deixaria a etapa dele ativa e a listagem
 * voltaria VAZIA sem explicação: o backend compõe os dois filtros com E
 * (`funnelId IN (...) AND stepId IN (...)`), e nenhum lead casa as duas
 * condições ao mesmo tempo. O usuário veria "nenhum lead encontrado" com dois
 * chips que, lidos em voz alta, parecem perfeitamente razoáveis.
 *
 * A poda é conservadora: etapa cujo funil dono ainda não carregou
 * (`stepsByFunnel` sem a entrada, e portanto o id é desconhecido) é MANTIDA.
 * "Não sei de quem é esta etapa" não é motivo para descartar escolha do
 * usuário — só descartamos o que sabemos ter ficado órfão.
 */
export function pruneStepsOutsideFunnels(
  filters: LeadsAdvancedFilters,
  nextFunnelIds: string[],
  stepsByFunnel: Record<string, Array<{ id: string }>>,
): LeadsAdvancedFilters {
  const current = filters.stepId;
  if (!current) return filters;

  const selected = Array.isArray(current) ? current : [current];
  const allowed = new Set(nextFunnelIds.flatMap((id) => (stepsByFunnel[id] ?? []).map((step) => step.id)));
  const known = new Set(Object.values(stepsByFunnel).flatMap((steps) => steps.map((step) => step.id)));

  const kept = selected.filter((stepId) => allowed.has(stepId) || !known.has(stepId));
  if (kept.length === selected.length) return filters;

  const { stepId: _dropped, ...rest } = filters;
  return kept.length > 0 ? { ...rest, stepId: kept } : rest;
}
